export enum MessageEnum {
  DELETE = 'MESSAGE DELETED',
  FAILED = 'METHOD FAILED'
}
